enum RouteEnum {
    home = '/',
    about = '/about',
    partnerships = '/partnerships',
    services = '/services',
    deedOfTemporaryGuardianship = '/deed-of-temporary-guardianship',
    enduringPowerOfAttorney = '/enduring-power-of-attorney',
    onlineWills = '/online-wills',
    estatePlanningSession = '/estate-planning-session',
    storageMembership = '/storage-membership',
    premiumWills = '/premium-wills',
    listOfAssets = '/list-of-assets',
    charities = '/charities',
    blog = '/blog',
    willGuide = '/guide-how-do-i-write-my-will',
    contact = '/contact',
    helpCenter = '/help-center',
    privacyPolicy = '/privacy-policy',
    termsOfService = '/terms-of-service',
    comparison = '/comparison',
    faqCountrySpecific = '/help-center/country-specific-will-service',
    faqDeedTemporary = '/help-center/temporary-guardianship-service',
    faqPowerOfAttorney = '/help-center/enduring-power-of-attorney',
    faqPremiumWill = '/help-center/premium-will-service',
    faqOnlineWill = '/help-center/online-will-service',
    faqEstatePlanningSession = '/help-center/estate-planning-session-service',
    faqStorageMembership = '/help-center/storage-membership',
}

export default RouteEnum;
